/** DOM event fired when a photographer saved an album or changed a frame guests can see. */
export const GALLERY_UPDATED_EVENT = 'catalogofworks:gallery-updated';

export function dispatchGalleryUpdated(galleryId: string): void {
  window.dispatchEvent(new CustomEvent(GALLERY_UPDATED_EVENT, { detail: { galleryId } }));
}

/** DOM event fired when a guest sends a frame choice to the photographer. */
export const GALLERY_SELECTION_EVENT = 'catalogofworks:gallery-selection-created';

export function dispatchGallerySelectionCreated(): void {
  window.dispatchEvent(new CustomEvent(GALLERY_SELECTION_EVENT));
}
